import * as tslib_1 from "tslib";
import { IgrGridColumnOptionsBase } from "./igr-grid-column-options-base";
var IgrGridColumnOptionsSectionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridColumnOptionsSectionBase, _super);
    function IgrGridColumnOptionsSectionBase(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IgrGridColumnOptionsSectionBase.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridColumnOptionsSectionBase;
}(IgrGridColumnOptionsBase));
export { IgrGridColumnOptionsSectionBase };
//# sourceMappingURL=igr-grid-column-options-section-base.js.map
